<template>
  <vx-card class="editor-mid-card overflow-hidden">
    <!-- <vue-perfect-scrollbar class="scroll-area" :settings="settings"> -->
    <div class="mb-base">
      <div class="flex justify-between flex-wrap mb-1">
        <vs-row vs-w="6">
          <h3 class="float-left mr-4">{{ $t("editor.skills.title") }}</h3>
          <vx-tooltip v-if="saveInProgress" text="Saving to cloud...">
            <feather-icon
              icon="CloudIcon"
              class="save-in-progress-status-icon"
              svgClasses="text-success"
          /></vx-tooltip>
          <vx-tooltip v-else 
            :text="$t('editor.skills.saveToCloud')"
            ><feather-icon
              icon="CloudIcon"
              class="save-in-progress-status-icon"
          /></vx-tooltip>
        </vs-row>
        <div>
          <options
            :previousMove="{ name: 'editor-educational-qualifications' }"
            :nextMove="{ name: 'editor-personality' }"
          />
        </div>
      </div>
      <!-- <p v-if="!isUserLoggedIn" class="text-danger">
          You are not authenticated. Please login to save your data.
        </p>
        <p v-else-if="internetConnectionStatus">
          Internet Connection Active. Keep editing and your data gets auto-saved.
        </p>
        <p v-else class="text-danger">
          No Internet Connection. Please connect to Internet to save your data.
        </p> -->
      <p v-if="!isUserLoggedIn">
        <span v-if="organizationSlug === 'default'">
          {{ $t("editor.utils.notAuthenticated.youAreNotAuthenticated") }}
          <router-link :to="{ name: 'editor-about' }">{{
            $t("editor.utils.notAuthenticated.login")
          }}</router-link>
          {{ $t("editor.utils.notAuthenticated.toSaveYourData") }}
        </span>
        <span v-else>
          {{ $t("editor.utils.notAuthenticated.youAreNotAuthenticated") }}
          <router-link :to="{ name: 'editor-about-custom' }">{{
            $t("editor.utils.notAuthenticated.login")
          }}</router-link>
          {{ $t("editor.utils.notAuthenticated.toSaveYourData") }}
        </span>
      </p>
    </div>
    <div class="main-form mb-base h-full">
      <!-- <vs-row class="mb-base">
          <label>Profession</label>
          <vs-input
            class="w-full"
            name="Profession"
            :disabled="disableInputField"
            v-model="localData.profession"
            @blur="saveField('saveProfession')"
          />
        </vs-row> -->

      <!-- Skills -->
      <vs-row class="mb-base">
        <label>{{ $t("editor.skills.skills") }}</label>
        <v-select
          class="w-full mb-4 vselect"
          name="Skills"
          :taggable="true"
          v-model="localSkill"
          :options="skillOptions"
          :disabled="disableInputField"
          @input="saveField('saveSkills')"
        />
        <draggable
          :list="localExtraCurricularData.skills"
          :group="{ name: 'tags', pull: 'clone', put: false }"
          class="p-2 cursor-move"
          @end="saveField('saveSkills')"
        >
          <vs-chip
            class="mr-3"
            @click="removeSkill(index)"
            v-for="(chip, index) in localExtraCurricularData.skills"
            vs-trigger-click
            :key="index"
            :color="chipsColor"
            closable
          >
            <p class="text-dark">{{ chip.title }}</p>
            <vs-dropdown
              vs-custom-content
              vs-trigger-click
              class="cursor-pointer ml-3"
              :id="`skill-rating-popup` + index"
              @click="clearSkillRatingText(index)"
            >
              <feather-icon
                icon="StarIcon"
                class="cursor-pointer mt-1 sm:mr-6 mr-2 text-warning"
                svgClasses="fill-current"
                :badge="chip.level"
              />
              <vs-dropdown-menu
                class="notification-dropdown dropdown-custom vx-navbar-dropdown"
              >
                <div
                  class="notification-top text-center p-3 bg-primary text-white"
                >
                  <h5 class="text-white">Rate this Skill</h5>
                </div>
                <div class="p-3">
                  <!-- <div v-if="chip.level" class="items-center mb-3 font-bold">{{ getSkillRatingText(chip.level) }}</div> -->
                  <div class="items-center mb-3 font-bold"></div>

                  <div
                    class="items-center mb-3 font-bold"
                    v-if="skillRatingChosen"
                  >
                    {{ currentSkillRatingText }}
                  </div>
                  <div class="items-center mb-3 font-bold" v-else>
                    {{ getSkillRatingText(chip.level) }}
                  </div>

                  <div class="mb-3">
                    <star-rating
                      style="justify-content: center"
                      :show-rating="false"
                      @rating-selected="saveSkillLevel"
                      @current-rating="setCurrentSkillIndex"
                      @mouseover.native="skillRatingChosen = true"
                      @mouseleave.native="skillRatingChosen = false"
                      :rating="chip.level"
                      :star-size="30"
                      :active-color="activeColor"
                    ></star-rating>
                  </div>
                  <div>
                    <vs-checkbox
                      v-model="
                        localExtraCurricularData.skills[index].activateLearning
                      "
                      :disabled="disableInputField"
                      @change="saveField('saveSkills')"
                      class="mb-3"
                      ><small>
                        Would you like to develop this skill further on
                        priority?
                      </small>
                    </vs-checkbox>
                    <small
                      >Mark the skills that you would like to develop and get
                      microlearning content feed on your development
                      charter.</small
                    >
                  </div>
                </div>
              </vs-dropdown-menu>
            </vs-dropdown>
          </vs-chip>
        </draggable>
      </vs-row>

      <!-- Languages -->
      <vs-row class="mb-base">
        <label>{{ $t("editor.skills.languages") }}</label>
        <v-select
          class="w-full mb-4 vselect"
          name="Languages"
          :taggable="true"
          v-model="localLanguage"
          :options="languageOptions"
          :disabled="disableInputField"
          @input="saveField('saveLanguages')"
        />
        <draggable
          :list="localExtraCurricularData.languages"
          :group="{ name: 'tags', pull: 'clone', put: false }"
          class="p-2 cursor-move"
          @end="saveField('saveLanguages')"
        >
          <vs-chip
            class="mr-3"
            @click="removeLanguage(index)"
            v-for="(chip, index) in localExtraCurricularData.languages"
            :key="index"
            :color="chipsColor"
            closable
          >
            <p class="text-dark">{{ chip.title.label }}</p>
            <vs-dropdown
              vs-custom-content
              vs-trigger-click
              :id="`language-rating-popup` + index"
              class="cursor-pointer ml-3"
              @click="clearLanguageRatingText(index)"
            >
              <feather-icon
                icon="StarIcon"
                class="cursor-pointer mt-1 mr-6 text-warning"
                svgClasses="fill-current"
                :badge="chip.level"
              />
              <vs-dropdown-menu
                class="notification-dropdown dropdown-custom vx-navbar-dropdown"
              >
                <div
                  class="notification-top text-center p-3 bg-primary text-white"
                >
                  <h5 class="text-white">Rate this Language</h5>
                </div>
                <div class="p-3">
                  <!-- <div v-if="chip.level" class="items-center mb-3 font-bold">{{ getLanguageRatingText(chip.level) }}</div> -->
                  <div
                    class="items-center mb-3 font-bold"
                    v-if="languageRatingChosen"
                  >
                    {{ currentLanguageRatingText }}
                  </div>
                  <div class="items-center mb-3 font-bold" v-else>
                    {{ getLanguageRatingText(chip.level) }}
                  </div>
                  <div class="mb-3">
                    <star-rating
                      style="justify-content: center"
                      :show-rating="false"
                      @rating-selected="saveLanguageLevel"
                      @current-rating="setCurrentLanguageIndex"
                      @mouseover.native="languageRatingChosen = true"
                      @mouseleave.native="languageRatingChosen = false"
                      :rating="chip.level"
                      :star-size="30"
                      :active-color="activeColor"
                    ></star-rating>
                  </div>
                  <div>
                    <vs-checkbox
                      v-model="
                        localExtraCurricularData.languages[index]
                          .activateLearning
                      "
                      :disabled="disableInputField"
                      @change="saveField('saveLanguages')"
                      class="mb-3"
                      ><small>
                        Would you like to learn this language further?
                      </small>
                    </vs-checkbox>
                    <small
                      >ALEX can recommend language content to suggest you
                      resources for learning.</small
                    >
                  </div>
                </div>
              </vs-dropdown-menu>
            </vs-dropdown>
          </vs-chip>
        </draggable>
      </vs-row>
      <!-- <vs-row class="mb-base">
          <label>Hobbies</label>
          <v-select
            class="w-full extra-curricular"
            name="Hobbies"
            multiple
            :taggable="true"
            :closeOnSelect="false"
            v-model="localExtraCurricularData.hobbies"
            :options="hobbyOptions"
            :disabled="disableInputField"
            @input="saveField('saveHobbies')"
          />
        </vs-row> -->

      <!-- Hobbies -->
      <vs-row class="mb-base">
        <label>{{ $t("editor.skills.hobbies") }}</label>
        <v-select
          class="w-full mb-4 vselect"
          name="Hobbies"
          :taggable="true"
          v-model="localHobby"
          :options="hobbyOptions"
          :disabled="disableInputField"
          @input="saveField('saveHobbies')"
        />
        <vs-chip
          class="mr-3"
          @click="removeHobby(index)"
          v-for="(chip, index) in localExtraCurricularData.hobbies"
          :key="index"
          :color="chipsColor"
          closable
        >
          <vs-dropdown
            vs-custom-content
            vs-trigger-click
            class="cursor-pointer"
            @click="clearLanguageRatingText(index)"
          >
            <!-- <feather-icon
                  icon="StarIcon"
                  class="cursor-pointer mt-1 mr-6 text-warning"
                  svgClasses="fill-current"
                  :badge="chip.level"
                /> -->
            <vs-icon
              v-if="chip.icon"
              class="mt-1 mr-3 cursor-pointer"
              color="primary"
              :icon="chip.icon"
              size="small"
              @click="addHobbyIcon(index)"
            />
            <feather-icon
              v-else
              class="mr-3 cursor-pointer"
              icon="PlusIcon"
              svgClasses="text-primary"
              @click="addHobbyIcon(index)"
            />
            <vs-dropdown-menu
              class="notification-dropdown dropdown-custom vx-navbar-dropdown"
            >
              <div
                class="notification-top text-center p-3 bg-primary text-white"
              >
                <h5 class="text-white">Add Icon to this Hobby</h5>
              </div>
              <div class="p-3">
                <!-- <virtual-list class="vs-row" style="height: 350px; width: 100%; overflow-y: auto;"
                          :data-key="'id'"
                          :data-sources="allIconArrayList"
                          :data-component="HobbyIcon"
                          @saveHobbyIcon="saveHobbyIcon"
                        /> -->
                <vs-input
                  class="w-full mb-3"
                  name="Hobby Icon"
                  v-model="hobbyIconSearchQuery"
                  placeholder="Search..."
                  @input="searchHobbyIcon"
                />
                <vue-perfect-scrollbar
                  class="hobby-icon-list-scroll-area"
                  :settings="settings"
                >
                  <vs-row
                    v-for="(iconArray, index1) in allIconArrayList"
                    :key="index1"
                  >
                    <vs-col
                      v-for="(src, index2) in iconArray.data"
                      :key="index2"
                      vs-w="1"
                    >
                      <vs-icon
                        class="hobby-icon-item cursor-pointer float-left"
                        :icon="src.id"
                        size="small"
                        @click="saveHobbyIcon(index, src.id)"
                      />
                    </vs-col>
                  </vs-row>
                  <div class="items-center">
                    <small v-if="!allIconArrayList.length">
                      Oops! Please try a different search query.
                    </small>
                  </div>
                </vue-perfect-scrollbar>
              </div>
            </vs-dropdown-menu>
          </vs-dropdown>
          <p class="text-dark mr-3">{{ chip.metaData.label }}</p>
        </vs-chip>
      </vs-row>
    </div>
    <!-- </vue-perfect-scrollbar> -->
  </vx-card>
</template>

<script>
import FeatherIcon from "../../components/FeatherIcon.vue";
import Options from "./components/Options.vue";
import constants from "@/constants";
import { saveInputFieldService } from "@/services/editor/skills.service.js";
import vSelect from "vue-select";
import _ from "lodash";
import StarRating from "vue-star-rating";
// import colors from "../../../themeConfig";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import allLanguages from "@/assets/data/all-languages.js";
import allSkills from "@/assets/data/all-skills.js";
import allHobbies from "@/assets/data/all-hobbies.js";
import allMaterialIcons from "@/assets/data/all-material-icons.js";
import draggable from "vuedraggable";

export default {
  components: {
    FeatherIcon,
    Options,
    vSelect,
    StarRating,
    VuePerfectScrollbar,
    draggable,
  },
  name: "EditorSkills",
  data() {
    return {
      localData: {},
      localExtraCurricularData: {},
      constants,
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
      },
      skillOptions: allSkills,
      languageOptions: allLanguages,
      hobbyOptions: allHobbies,
      allMaterialIcons,
      allIconArrayList: [],
      activeColor: "#F29300",
      currentSkillIndex: null,
      chipsColor: "rgba(136, 136, 136, 0.1)",
      currentSkillRatingText: "",
      currentLanguageRatingText: "",
      hobbyIconSearchQuery: "",
      languageRatingChosen: false,
      skillRatingChosen: false,
    };
  },
  computed: {
    otpSent() {
      return this.$store.state.auth.otpSent;
    },
    saveInProgress() {
      return this.$store.state.editor.saveInProgress;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    usersData() {
      return this.$store.state.users.data;
    },
    extraCurricular() {
      return this.$store.state.editor.extraCurricular;
    },
    localSkill: {
      get() {
        return null;
      },
      set(newVal) {
        const tempSkillArray = [];

        this.localExtraCurricularData.skills.forEach((element) => {
          tempSkillArray.push(element.title);
        });

        if (tempSkillArray.includes(newVal)) {
          return;
        }

        let newSkill = {
          title: newVal,
          level: 5,
        };
        this.localExtraCurricularData.skills.push(newSkill);
        this.saveField("saveSkills");
        setTimeout(() => {
          document
            .getElementById(
              "skill-rating-popup" +
                (this.localExtraCurricularData.skills.length - 1)
            )
            .click();
        }, 100);
      },
    },
    localLanguage: {
      get() {
        return null;
      },
      set(newVal) {
        const tempLanguageArray = [];
        this.localExtraCurricularData.languages.forEach((element) => {
          tempLanguageArray.push(element.title);
        });

        if (tempLanguageArray.includes(newVal)) {
          return;
        }

        let newLanguage = {
          title: newVal,
          level: 5,
        };
        this.localExtraCurricularData.languages.push(newLanguage);
        this.saveField("saveLanguages");
        setTimeout(() => {
          document
            .getElementById(
              "language-rating-popup" +
                (this.localExtraCurricularData.languages.length - 1)
            )
            .click();
        }, 100);
      },
    },
    localHobby: {
      get() {
        return null;
      },
      set(newVal) {
        const tempHobbyArray = [];

        this.localExtraCurricularData.skills.forEach((element) => {
          tempHobbyArray.push(element);
        });

        if (tempHobbyArray.includes(newVal)) {
          return;
        }
        this.localExtraCurricularData.hobbies.push({ metaData: newVal });
        this.saveField("saveHobbies");
      },
    },
    skills() {
      return this.$store.state.editor.extraCurricular.skills;
    },
    languages() {
      return this.$store.state.editor.extraCurricular.languages;
    },
    hobbies() {
      return this.$store.state.editor.extraCurricular.hobbies;
    },
    userId() {
      return this.$store.state.auth.user._id;
    },
    internetConnectionStatus() {
      return this.$store.state.users.internetConnectionStatus;
    },
    disableInputField() {
      return !this.isUserLoggedIn || !this.internetConnectionStatus;
    },
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },
  },
  watch: {
    usersData(newVal) {
      if (newVal) {
        this.localData = JSON.parse(JSON.stringify(newVal));
      }
    },
    extraCurricular(newVal) {
      if (newVal) {
        this.localExtraCurricularData = JSON.parse(JSON.stringify(newVal));
      }
    },
    skills(newVal) {
      if (newVal) {
        // console.log(newVal);
        this.localExtraCurricularData.skills = JSON.parse(
          JSON.stringify(newVal)
        );
        if (this.currentSkillIndex && this.currentSkillIndex.level) {
          return this.setCurrentSkillIndex(
            newVal[this.currentSkillIndex].level
          );
        }
      }
    },
    languages(newVal) {
      if (newVal) {
        this.localExtraCurricularData.languages = JSON.parse(
          JSON.stringify(newVal)
        );
        if (this.currentLanguageIndex && this.currentLanguageIndex.level) {
          return this.setCurrentLanguageIndex(
            newVal[this.currentLanguageIndex].level
          );
        }
      }
    },
    hobbies(newVal) {
      if (newVal) {
        this.localExtraCurricularData.hobbies = JSON.parse(
          JSON.stringify(newVal)
        );
      }
    },
  },
  methods: {
    clearSkillRatingText(index) {
      this.currentSkillRatingText = "";
      this.currentSkillIndex = index;
    },
    getSkillRatingText(rating) {
      if (rating < 3) return "Beginner";
      else if (rating > 3) return "Advanced";
      else return "Intermediate";
    },
    setCurrentSkillIndex(rating) {
      this.currentSkillRatingText = this.getSkillRatingText(rating);
    },
    saveSkillLevel(rating) {
      this.localExtraCurricularData.skills[this.currentSkillIndex].level =
        rating;
      this.saveField("saveSkills");
    },
    removeSkill(index) {
      this.localExtraCurricularData.skills.splice(index, 1);
      this.saveField("saveSkills");
    },

    clearLanguageRatingText(index) {
      this.currentLanguageRatingText = "";
      this.currentLanguageIndex = index;

      // Initialize hobby icons
      if (this.hobbyIconSearchQuery) {
        this.hobbyIconSearchQuery = null;
        this.loadHobbyIcons();
      }
    },
    getLanguageRatingText(rating) {
      if (rating === 1) return "Basic (A1/A2)";
      if (rating === 2) return "Independent (B1)";
      if (rating === 3) return "Independent (B2)";
      if (rating === 4) return "Proficient (C1)";
      if (rating === 5) return "Native (C2)";
    },
    setCurrentLanguageIndex(rating) {
      this.currentLanguageRatingText = this.getLanguageRatingText(rating);
    },
    saveLanguageLevel(rating) {
      this.localExtraCurricularData.languages[this.currentLanguageIndex].level =
        rating;
    },
    removeLanguage(index) {
      this.localExtraCurricularData.languages.splice(index, 1);
      this.saveField("saveLanguages");
    },

    removeHobby(index) {
      this.localExtraCurricularData.hobbies.splice(index, 1);
      this.saveField("saveHobbies");
    },
    addHobbyIcon(index) {
      this.currentHobbyIndex = index;
      // console.log('add hobby icon');
    },
    loadHobbyIcons() {
      // Load all hobby icons
      let count = 0;
      let chunkArrayList = [];
      this.allIconArrayList = [];
      this.allMaterialIcons.categories.forEach((category) => {
        category.icons.forEach((i) => {
          // // console.log(JSON.parse(JSON.stringify(i.keywords[0].includes(this.hobbyIconSearchQuery))), i.keywords[0], this.hobbyIconSearchQuery);
          if (
            !this.hobbyIconSearchQuery ||
            i.keywords[0].includes(this.hobbyIconSearchQuery)
          ) {
            chunkArrayList.push(i);
            count++;
            if (count === 12) {
              this.allIconArrayList.push({ id: count, data: chunkArrayList });
              count = 0;
              chunkArrayList = [];
            }
          }
        });
      });

      if (count < 12 && count !== 0)
        this.allIconArrayList.push({ id: count, data: chunkArrayList });

      // console.log(this.allIconArrayList);
    },
    async searchHobbyIcon() {
      /*this.allIconArrayList = this.allMaterialIcons.find(icon => {
        return icon.keywords.includes(this.hobbyIconSearchQuery);
      });*/
      _.throttle(function (currentThis) {
        currentThis.loadHobbyIcons();
      }, 800)(this);
    },
    saveHobbyIcon(index, icon) {
      // console.log(index, icon);
      // console.log(this.localExtraCurricularData.hobbies, index);
      this.localExtraCurricularData.hobbies[index].icon = icon;
      this.currentHobbyIndex = null;
      this.saveField("saveHobbies");
    },

    async saveField(action, fieldName = null) {
      let fieldIsValid = false;

      if (fieldName) {
        fieldIsValid = await this.$validator.validate(fieldName);

        if (!fieldIsValid) {
          return;
        }
      } else {
        fieldIsValid = true;
      }

      //// console.log(fieldIsValid);

      if (fieldName && !fieldIsValid) {
        return;
      }

      const payload = {
        isUserLoggedIn: this.isUserLoggedIn,
        action,
        localData: this.localData,
        localExtraCurricularData: this.localExtraCurricularData,
        userId: this.userId,
        currentThis: this,
      };

      //// console.log(payload);

      saveInputFieldService(payload);
    },
  },
  mounted() {},
  created() {
    this.$store.dispatch("editor/toggleRightBar", true);
    this.$store.dispatch("editor/togglePreviewMode", false);

    if (this.isUserLoggedIn) {
      if (Object.keys(this.usersData).length) {
        this.localData = JSON.parse(JSON.stringify(this.usersData));
      }
      if (Object.keys(this.extraCurricular).length) {
        this.localExtraCurricularData = JSON.parse(
          JSON.stringify(this.extraCurricular)
        );
      }
    }

    // Load all hobby icons
    let count = 0;
    let chunkArrayList = [];
    this.allMaterialIcons.categories.forEach((category) => {
      category.icons.forEach((i) => {
        chunkArrayList.push(i);
        count++;
        if (count === 12) {
          this.allIconArrayList.push({ id: count, data: chunkArrayList });
          count = 0;
          chunkArrayList = [];
        }
      });
    });
    // console.log(this.allIconArrayList);
  },
};
</script>

<style scoped>
.hobby-icon-list-scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 300px;
  /*height: 1000px;*/
}
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 615px;
  /*height: 1000px;*/
}
.vs--searchable >>> .vs__dropdown-toggle {
  /*min-height: 50px !important;*/
  background: #fbfbfc;
  border: 1px solid #ebedf0;
  box-sizing: border-box;
  border-radius: 6px;
}

.v-select >>> .vs__dropdown-toggle {
  /*padding: 5px 5px 9px 5px;*/
}

.v-select >>> .vs__open-indicator {
  cursor:pointer
}

.extra-curricular >>> .vs__selected {
  /* Auto Layout */

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 14px;

  background: #eaeaea !important;
  border-radius: 100px !important;

  /* Inside Auto Layout */

  flex: none;
  order: 0;
  flex-grow: 0;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 30px;
  /* identical to box height, or 214% */

  letter-spacing: -0.02em;
  text-transform: capitalize;

  color: #868686;

  /* Inside Auto Layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

.feather-icon-badge {
  background-color: transparent !important;
  color: rgba(var(--vs-primary), 1) !important;
  font-weight: 700 !important;
}

.hobby-icon-item:hover {
  background-color: #f29300;
  color: white;
}

.vselect >>> ul {
  max-height: 120px;
}
</style>
